import { render, staticRenderFns } from "./TlmFieldNewsPermissionRadios.vue?vue&type=template&id=ed529aea"
import script from "./TlmFieldNewsPermissionRadios.vue?vue&type=script&lang=js"
export * from "./TlmFieldNewsPermissionRadios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports